import { some } from 'lodash/fp';

import { ADULT_AGE_MIN, FIELD_NAMES, TRAVELLER_AGE_FIELDS } from '../../constants';
import { FormValues } from '../../types';

const getHasChildDependents = ({ formikValues }: { formikValues: FormValues }) =>
  some((field) => {
    const isFirstTraveller = field === FIELD_NAMES.TRAVELLER_AGE_1;
    if (isFirstTraveller) return false;
    const value = formikValues[field as keyof FormValues];

    return Boolean(value) && Number(value) < ADULT_AGE_MIN;
  }, TRAVELLER_AGE_FIELDS);

export default getHasChildDependents;
